import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PublicationListPage } from "@client/components/admin/publications/publication-list-page";
import type { PublicationTab } from "@client/components/admin/publications/publication-shared";

function isPublicationTab(v: unknown): v is PublicationTab {
  return v === "pending" || v === "history" || v === "settings";
}

/**
 * 团队设置-发布审核(标准化表格改造)
 *
 * 复用 admin/publications 的 DataTable 标准实现(待审核/审核历史两 tab,
 * 标题与 tab 注入 SecondaryNav 顶栏,前端分页 + 资源名搜索 + 审核对话框),
 * 本路由只负责 search param 校验与 tab 切换导航。
 */
export const Route = createFileRoute("/_app/tenant-settings/publications")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: isPublicationTab(search.tab) ? search.tab : "pending",
  }),
  component: PublicationsPage,
});

function PublicationsPage() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: "/tenant-settings/publications" });
  return (
    <PublicationListPage
      tab={tab}
      onTabChange={(v) => navigate({ search: { tab: v }, replace: true })}
    />
  );
}
